export default __webpack_public_path__ + "9caa77475c00aae7b371c844211f5168.png";